import React from 'react';

import { Acoes, Cabecalho, Container } from './styles';

interface PaginaProps {
  titulo: string;
  subtitulo?: string;
  acoes?: React.ReactNode;
  children?: React.ReactNode;
}

// Moldura padrão das telas internas: título, ações à direita e conteúdo
export default function Pagina({ titulo, subtitulo, acoes, children }: PaginaProps) {
  return (
    <Container>
      <Cabecalho>
        <div>
          <h1>{titulo}</h1>
          {subtitulo && <p>{subtitulo}</p>}
        </div>
        {acoes && <Acoes className='nao-imprimir'>{acoes}</Acoes>}
      </Cabecalho>
      {children}
    </Container>
  );
}
